export const LogoMark = ({ className = "h-9 w-9" }) => (
    <img
        src="/logo.jpg"
        alt="SPICEJAM KITCHEN logo"
        className={`${className} rounded-full object-cover`}
        data-testid="logo-mark"
    />
);

export default LogoMark;
